import React, { useState, useEffect } from 'react';
import intl from 'react-intl-universal';
import { Image, Button, Toast } from 'antd-mobile'

import CouponType from './CouponType';
import dayjs from 'dayjs';
import styles from './select.module.less';
import { formatJSON } from '../../utils';
import { getExpiredText, getCouponTypeText, getDiscountDisplay, getReachCanUseText } from '../../utils/coupon';
import Header from '../Header';
import math from '../../utils/math';

const SelectCoupons = ({ ids, from = '', list = [], callback }) => {
    const [selectedCoupon, setSelectedCoupon] = useState(null);

    const isCouponDisabled = (item) => {
        if (item.status === 1) return true;
        if (item.couponReach && item.couponReach > item.productAmount) return true;
        if (item.couponReachNum && item.couponReachNum > item.totalNum) return true;
        return false;
    }

    const getCouponTips = (item) => {
        if (item.couponReach && item.couponReach > item.productAmount) {
            const remain = math.sub(item.couponReach, item.productAmount);
            return intl.get('equity_remain_x_can_use', { amount: remain }).d(`还差 ${remain} 可用`);
        }
        if (item.couponReachNum && item.couponReachNum > item.totalNum) {
            const remain = math.sub(item.couponReachNum, item.totalNum);
            return intl.get('equity_remain_x_num_can_use', { amount: remain }).d(`还差 ${remain} 件可用`);
        }
        return '';
    }

    const handleCouponSelect = (coupon) => {
        if (isCouponDisabled(coupon)) return;
        setSelectedCoupon(coupon);
        callback?.(coupon);
    }

    const handleNoCoupon = () => {
        setSelectedCoupon(null);
        callback?.(null);
    }

    return (
        <div className={styles.couponContainer}>
            <Header title={intl.get('od_select_coupon').d('选择优惠券')} back={false} />
            <div className={styles.couponList}>
                {list.length > 0 ? (
                    <ul className={styles.couponUl}>
                        {list.map((item, index) => {
                            const isDisabled = isCouponDisabled(item);
                            const tips = getCouponTips(item);
                            const isSelected = selectedCoupon?.couponId === item.couponId;

                            return (
                                <li
                                    key={index}
                                    className={`${styles.couponItem} ${isSelected ? styles.active : ''} ${isDisabled ? styles.disabled : ''}`}
                                    onClick={() => handleCouponSelect(item)}
                                >
                                    <div className={styles.couponMain}>
                                        <div className={styles.couponLeft}>
                                            <div className={styles.couponType}>{getCouponTypeText(item.couponType)}</div>
                                            <div className={styles.discount}>{getDiscountDisplay(item)}</div>
                                            <div className={styles.threshold}>  {getReachCanUseText(item)}  </div>
                                            {item.useTimeStr && (
                                                <p className={styles.useTime}>
                                                    {intl.get('equity_use_time').d('Use time')}: {item.useTimeStr}
                                                </p>
                                            )}
                                        </div>
                                        <div className={styles.couponRight}>
                                            <p className={styles.couponName}>{item.couponName}</p>
                                            <p className={styles.validDate}>{getExpiredText(item)}</p>
                                            {tips && (
                                                <div className={styles.tips}>
                                                    <span className={styles.danger}>*</span> {tips}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <div className={styles.emptyList}>
                        {intl.get('no_coupons').d('暂无优惠券')}
                    </div>
                )}
            </div>
            <div className={styles.bottomButton}>
                <Button
                    block
                    onClick={handleNoCoupon}
                    className={styles.noCouponButton}
                >
                    {intl.get('h_back').d('Back')}
                </Button>
            </div>
        </div>
    );
};

export default SelectCoupons;